import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { PageLayout } from '@Local/Components/Layout';

import useProductApi from '@Apis/useProductApi';
import useOptions from '@Util/hook/useOptions';
import { ensureValidOptions } from '@Util/utils';
import { PRODUCT_DETAIL_ROUTER_URL, PRODUCT_OVERVIEW_ROUTER } from '@Router/routerPath';
import ProductForm from '@Local/Product/Form/ProductForm';

/**
 * 新增商品頁（`/site/product/add`）
 */
const ProductAddPage = () => {
    const history = useHistory();
    const { postProductApi, getProductOptionsApi } = useProductApi();
    // 取得商品選項（新增／編輯的分類不含「全部」）
    const getOptionsApi = useCallback(() => getProductOptionsApi({ skipAll: true }), [getProductOptionsApi]);
    // 商品選項（分類樹、上下架選項）
    const { options } = useOptions({ getOptionsApi, isFetchOnMount: true });

    return (
        <PageLayout>
            <PageLayout.Header title="新增商品" />

            <ProductForm
                categoryOptions={ensureValidOptions(options.categoryOptions)}
                submitApi={postProductApi}
                onSuccess={(productID) => history.push(PRODUCT_DETAIL_ROUTER_URL(productID))}
                onCancel={() => history.push(PRODUCT_OVERVIEW_ROUTER)}
            />
        </PageLayout>
    );
};

export default ProductAddPage;
